export * from "./trip-config";
